import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import '../src/survey-ui/assets/css/bootstrap.min.css';
// import '../src/survey-ui/assets/css/style.css';
// import '../src/survey-ui/assets/css/responsive.css';
import App from "./App";
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from "react-redux";
import store from "./survey-ui/store/store";

ReactDOM.render(
  <BrowserRouter>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
reportWebVitals();

